import { render, staticRenderFns } from "./MyRating.vue?vue&type=template&id=56d0e1c3&"
import script from "./MyRating.vue?vue&type=script&lang=js&"
export * from "./MyRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports